(function () {
  angular
    .module('kareo.ui.shared.directives.k-create-insurance-plan', [
      'angucomplete-alt',
      'kareo.ui.shared.directives.validation.input-group',
      'kareo.ui.shared.directives.validation.prevent-form-submit',
      'kareo.ui.shared.directives.templates',
      'kareo.ui.shared.directives.ui-mask',
      'kareo.ui.shared.directives.k-create-insurance-company',
      'kareo.ui.shared.modules.api.insurance-service'
    ])
    .directive('kCreateInsurancePlan', kCreateInsurancePlan)
  .run(['$templateCache', function ($templateCache) {
    $templateCache.put('k-create-insurance-plan/autocomplete-with-create.html', require('./autocomplete-with-create.pug')());
  }]);

  function kCreateInsurancePlan() {
    return {
      bindToController: true,
      controller,
      controllerAs: 'vm',
      restrict: 'E',
      scope: {
        onSuccess: '&',
        onCancel: '&',
        fieldId: '='
      },
      template: require('./k-create-insurance-plan.pug')()
    };
  }

  controller.$inject = ['insuranceService', '$scope'];

  function controller(insuranceService, $scope) {
    var vm = this;

    resetState();
    vm.companySearchURL = insuranceService.getCompanySearchURL();

    vm.confirmInsurancePlan = function () {
      vm.savingInsurancePlan = true;
      var createPlan = insuranceService.createInsuranceCompanyPlan(
        { planName: vm.planName,
          insuranceCompanyId: vm.insuranceCompanySelected.originalObject.insuranceCompanyId });

      vm.savingInsurancePlan = true;
      createPlan.then((data) => {
        vm.savingInsurancePlan = false;
        vm.closeSuccess({ planName: vm.planName, insuranceCompanyPlanId: data,insuranceCompanyId:vm.insuranceCompanySelected.originalObject.insuranceCompanyId });
      }, () => {
        vm.savingInsurancePlan = false;
        vm.errorCreatingPlan = true;
      });
    };

    vm.insuranceCompanyChanged = function (company) {
      if (!!company) {
        if (angular.equals(company.originalObject, {})) {
          vm.creatingInsuranceCompany = true; // display creation modal
        } else {
          vm.insuranceCompanySelected = company;
        }
      }
    };

    vm.createCompany = function (company) {
      if (company && !angular.equals(company, {})) {
        $scope.$broadcast('angucomplete-alt:changeInput', 'insuranceCompany', company);
      } else {
        $scope.$broadcast('angucomplete-alt:clearInput', 'insuranceCompany');
      }

      vm.creatingInsuranceCompany = false;
    };

    vm.closeSuccess = function (newInsurancePlan) {
      vm.onSuccess({ plan: newInsurancePlan, fieldId: vm.fieldId });
      resetState();
    };

    vm.closeCancel = function () {
      vm.onCancel();
      resetState();
    };

    function resetState() {
      vm.insuranceCompanySelected = {};
      vm.savingInsurancePlan = false;
      vm.errorCreatingPlan = false;
      vm.planName = '';
    }
  }
})();
